<template>
    <div class="p-2 bg-white">
        <h5>{{ title }}</h5>
        <small>{{ subtitle }}</small>
    </div>
</template>

<script>
    export default{
        props:{
            title:{
                type: String
            },
            subtitle:{
                type: String
            }
        }
    }
</script>